<div class="number-spinner">
  <button (click)="decrement($event)" class="spinner-dn" tabindex="-1" type="button" [disabled]="isDecrementButtonDisabled()">
    <svg-icon icon="minus"></svg-icon>
  </button>
  <div class="spinner-wrapper" [ngClass]="{'input-percent': appendPercent}">
    <input type="text" [attr.min]="minValue" [attr.max]="maxValue" [attr.step]="stepAmount" class="spinner" [(ngModel)]="numberValue" [disabled]="isInputDisabled">
  </div>
  <button (click)="increment($event)" class="spinner-up" tabindex="-1" type="button" [disabled]="isIncrementButtonDisabled()">
    <svg-icon icon="plus"></svg-icon>
  </button>
</div>

